import type { ElasticHit } from 'src/hooks/active-campaign-by-product-id';

export enum SortOptionValueEnum {
  RANK_DESC = 'rank|desc',
  PRODUCT_NAME_KEYWORD = 'product.name.keyword',
  PRODUCT_POPULARITY_TOTAL = 'product.popularity.total',
  PRICE_OFFER_ASC = 'price.offer|asc',
  PRICE_OFFER_DESC = 'price.offer|desc',
  PRODUCT_USER_REVIEWS_RATING_DESC = 'product.user_reviews.rating|desc',
  PRICE_DIFF_PERCENTAGE_DESC = 'price.diff_percentage|desc',
  RELEVANCE = 'relevance',
}

/* eslint-disable camelcase */
export type Source = ElasticHit['_source'] & {
  external_uri: string;
  product: {
    category: {
      name: string;
    };
    media: {
      product_images: {
        count: number;
        uri: string;
        first: { 140: string; 280: string; 800: string };
      };
    };
    name: string;
    semantic_id: string;
    user_reviews: {
      rating?: number | null;
      count: number;
    };
    web_uri: string;
    price?: {
      count_regular: number;
    };
  };
};
